<template>
  <div
    :class="['relative-position base-view-wrapper', { 'active': activeSection === name }]"
    @click="onClick"
  >
    <div
      v-if="isPreview"
      class="absolute full-width full-height highlight"
    >
      <div class="highlight-name border-radius-10">{{ title }}</div>
    </div>
    <slot />
  </div>
</template>

<script setup>
import { inject, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useBookPageStore } from 'stores/bookPage';
import { storeToRefs } from 'pinia';

const { t } = useI18n();
const bus = inject('bus');
const bookPageStore = useBookPageStore();
const { activeSection } = storeToRefs(bookPageStore);

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  isPreview: {
    type: Boolean,
    default: false,
  },
});

const title = computed(() => {
  const key = props.name.replace(/-./g, (x) => x[1].toUpperCase());

  return t(`label.${key}`);
});

function onClick() {
  if (props.isPreview) {
    bus.emit('toggle-section', props.name);
    activeSection.value = props.name;
  }
}
</script>

<style lang="scss" scoped>
.base-view-wrapper {
  .highlight {
    padding: 10px 16px;
    top: 0;
    left: 0;
    border: 2px dashed $grey-7;
    display: none;
    z-index: 3;

    .highlight-name {
      padding: 6px 12px;
      background: rgba(0, 0, 0, 0.29);
      color: #fff;
      width: fit-content;
    }
  }

  &:hover {
    .highlight {
      display: block;
    }
  }

  &.active {
    .highlight {
      display: block;
    }
  }
}
</style>
